<template>
  <div v-if="!showForgotPassword">
    <div v-if="whitelabel.brand == 'oldmutual'" class="drawer-signup-container">
      <div class="title-section">
        <h1>Log in</h1>
        <p>Use your email or other service to continue</p>
      </div>
      <div class="error-section">
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
      <div class="sso-section">
        <GoogleSsoSignIn @onError="onError"></GoogleSsoSignIn>
      </div>
      <div class="or-hr-section">
        <OrHr />
      </div>
      <div class="email-section">
        <SignInWithEmail
          @forgotPassword="forgotPassword"
          @onError="onError"
        ></SignInWithEmail>
      </div>
      <AlreadyHaveAnAccount :type="'login'" @signupClicked="signupClicked" />
    </div>
    <div v-else-if="whitelabel.brand == 'teba'" class="drawer-signup-container">
      <div class="title-section">
        <h1>Log in</h1>
        <p>Use your industry number to continue</p>
      </div>
      <div class="error-section">
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
      <div class="email-section">
        <SignInWithNumber @onError="onError" @forgotPassword="forgotPassword" />
      </div>
      <AlreadyHaveAnAccount :type="'login'" @signupClicked="signupClicked" />
    </div>
  </div>
  <div v-else>
    <div v-if="whitelabel.brand == 'oldmutual'" class="drawer-signup-container">
      <div class="title-section">
        <h1>Forgot password</h1>
        <p>Enter the email you signed up with</p>
      </div>
      <div class="error-section">
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
      <div class="email-section">
        <ForgotPasswordEmail @successResetPassword="successResetPassword" />
      </div>
    </div>
    <div v-else-if="whitelabel.brand == 'teba'" class="drawer-signup-container">
      <div class="title-section">
        <h1>Forgot password</h1>
        <p>{{ this.whitelabel.authentication.resetPassword.title }}</p>
      </div>
      <div class="error-section">
        <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      </div>
      <div class="email-section">
        <ForgotPasswordEmail @successResetPassword="successResetPassword" />
      </div>
    </div>
  </div>
</template>

<script>
import GoogleSsoSignIn from "../guest/GoogleSsoSignIn.vue";
import SignInWithEmail from "../guest/SignInWithEmail.vue";
import ForgotPasswordEmail from "../guest/ForgotPasswordEmail.vue";
import SignInWithNumber from "./SignInWithNumber.vue";
import OrHr from "../common/OrHr.vue";
import AlreadyHaveAnAccount from "./AlreadyHaveAnAccount.vue";

export default {
  name: "DrawerSignIn",
  components: {
    GoogleSsoSignIn,
    SignInWithEmail,
    SignInWithNumber,
    ForgotPasswordEmail,
    OrHr,
    AlreadyHaveAnAccount,
  },
  data() {
    return {
      acceptedTerms: true,
      errorMessage: "",
      showForgotPassword: false,
    };
  },
  props: {
    drawerOpen: {
      required: true,
      type: Boolean,
    },
  },
  computed: {},
  watch: {
    drawerOpen(newVal) {
      if (!newVal) {
        this.showForgotPassword = false;
      }
    },
  },
  methods: {
    successResetPassword() {
      this.showForgotPassword = false;
      this.$emit("successResetPassword");
    },
    signupClicked() {
      this.$emit("signupClicked");
    },
    forgotPassword() {
      this.showForgotPassword = true;
    },
    onError(error) {
      if (error) {
        if (error.message.includes("GraphQL error:")) {
          this.errorMessage = error.message
            .replace("GraphQL error:", "")
            .trim();
        } else {
          this.errorMessage =
            "Something went wrong, we're looking into it. Please try login again.";
          throw error;
        }
      } else {
        this.errorMessage = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer-signup-container {
  width: 100%;
  padding: 30px;

  .title-section {
    h1 {
      font-size: 22px;
      font-weight: 500;
      line-height: 30px;
      margin-bottom: 10px;
    }
    p {
      font-size: 14px;
      font-weight: 400;
      line-height: 18.2px;
      margin: 0;
    }
  }
  .sso-section {
    margin-top: 22px;
  }
  .or-hr-section {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  .error-section {
    p {
      margin: 0;
      margin-top: 16px;
      margin-bottom: 16px;
    }
  }
}
@media only screen and (min-width: 0px) and (max-width: 959px) {
  .drawer-signup-container {
    padding-left: 0;
    padding-right: 0;
  }
}
</style>
